import { render } from "./ValidationModal.vue?vue&type=template&id=50535dea&scoped=true"
import script from "./ValidationModal.vue?vue&type=script&lang=js"
export * from "./ValidationModal.vue?vue&type=script&lang=js"

import "./ValidationModal.vue?vue&type=style&index=0&id=50535dea&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50535dea"]])

export default __exports__